<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';
import {
  faInstagram,
  faYoutube,
  faFacebook,
  faMedium
} from '@fortawesome/free-brands-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
//import { faEnvelope } from '@fortawesome/pro-light-svg-icons';

const email = ref('');
const submitEmail = () => {
  if (email.value) {
    alert(`Thanks for subscribing, ${email.value}!`);
    email.value = '';
  }
};

// Font Awesome Icons
const socialIcons = [
  { name: 'instagram', icon: faInstagram, link: 'https://www.instagram.com/valvevista' },
  { name: 'youtube', icon: faYoutube, link: 'https://www.youtube.com/@valvevista' },
  { name: 'facebook', icon: faFacebook, link: 'https://www.facebook.com/valvevista/' },
  { name: 'medium', icon: faMedium, link: 'https://medium.com/@valvevista' },
];

// Micro links
const microLinks = [
  { text: 'Terms of Service', href: '#' },
  { text: 'Privacy Policy', href: '#' },
  { text: 'Warranty', href: '#' }
];

// Animate glow + pulse on hover
/*
const onIconHover = (e: any) => {
  gsap.to(e.currentTarget, {
    scale: 1.2,
    boxShadow: '0 0 10px #ff9f1c',
    duration: 0.3,
    ease: 'power2.out'
  });
};

const onIconLeave = (e: any) => {
  gsap.to(e.currentTarget, {
    scale: 1,
    boxShadow: '0 0 0px transparent',
    duration: 0.2
  });
};
 */

// Flickering glow text
const copyrightText = ref(null);

onMounted(() => {
  const flicker = () => {
    gsap.to(copyrightText.value, {
      opacity: gsap.utils.random(0.8, 1),
      duration: gsap.utils.random(0.1, 0.3),
      repeat: -1,
      yoyo: true,
      ease: 'none'
    });
  };
  flicker();
});
</script>

<template>
  <footer class="max-h-fit app-footer">
    <v-container>
      <!-- Social Icons -->
      <div class="footer-icons">
        <a v-for="icon in socialIcons"
           :key="icon.name"
           class="social-icon"
           :href="icon.link">
          <font-awesome-icon :key="icon.name"
                             :icon="icon.icon" />
        </a>
        <!--
        <font-awesome-icon v-for="icon in socialIcons"
                           :key="icon.name"
                           :icon="icon.icon"
                           class="social-icon"
                           @click="icon.link"

                           @mouseenter="onIconHover($event)"
                           @mouseleave="onIconLeave($event)" />
      -->
      </div>

      <!-- Newsletter -->
      <div class="newsletter">
        <label for="email">Join Mailing List:</label>
        <v-text-field class="text-gray-500"
                      id="email"
                      v-model="email"
                      placeholder="Enter your email"
                      hide-details
                      solo />
        <v-btn class="join-btn"
               @click="submitEmail">Join</v-btn>
      </div>

      <!-- Micro Links -->
      <div class="micro-links">
        <a v-for="link in microLinks"
           :key="link.text"
           :href="link.href">{{ link.text }}</a>
      </div>

      <!-- Copyright -->
      <div class="copyright">
        <span ref="copyrightText">© 2025 Valve Vista Sound Labs – Warming the World, One Tube at a Time</span>
      </div>
    </v-container>
  </footer>
</template>

<style scoped>
.app-footer {
  background: #0f0f0f;
  color: #f5f5f5;
  padding: 2rem 0;
  font-family: 'Orbitron', sans-serif;
  text-align: center;
  position: relative;
}

.footer-icons {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 1.5rem;
}

.social-icon {
  font-size: 2rem;
  cursor: pointer;
  transition: transform 0.3s;
}

.newsletter {
  margin-bottom: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.newsletter label {
  font-size: 1.1rem;
}

.join-btn {
  background-color: #ff9f1c;
  color: #fff;
  transition: all 0.3s;
}

.join-btn:hover {
  background-color: #ffa733;
  box-shadow: 0 0 10px #ff9f1c;
}

.micro-links {
  margin-bottom: 1.5rem;
}

.micro-links a {
  margin: 0 1rem;
  color: #aaa;
  text-decoration: none;
  font-size: 0.95rem;
}

.micro-links a:hover {
  color: #fff;
  text-decoration: underline;
}

.copyright {
  font-size: 0.85rem;
  color: #888;
  text-shadow: 0 0 6px rgba(255, 200, 100, 0.3);
}
</style>
